// Reference data for Profile / Settings page

export const COUNTRIES = [
  "USA", "India", "United Kingdom", "Canada", "Australia", "Germany", "France",
  "Spain", "Italy", "Netherlands", "Belgium", "Sweden", "Norway", "Denmark",
  "Finland", "Switzerland", "Austria", "Ireland", "Portugal", "Greece",
  "Japan", "South Korea", "China", "Singapore", "Hong Kong", "Taiwan",
  "United Arab Emirates", "Saudi Arabia", "Israel", "Turkey", "South Africa",
  "Egypt", "Nigeria", "Kenya", "Brazil", "Argentina", "Mexico", "Chile",
  "Colombia", "Peru", "New Zealand", "Indonesia", "Malaysia", "Thailand",
  "Vietnam", "Philippines", "Pakistan", "Bangladesh", "Sri Lanka", "Nepal",
  "All Country",
];

export const TIMEZONES = [
  { value: "UTC", label: "UTC (Coordinated Universal Time)" },
  { value: "America/New_York", label: "America/New_York (Eastern, US)" },
  { value: "America/Chicago", label: "America/Chicago (Central, US)" },
  { value: "America/Denver", label: "America/Denver (Mountain, US)" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles (Pacific, US)" },
  { value: "America/Anchorage", label: "America/Anchorage (Alaska, US)" },
  { value: "Pacific/Honolulu", label: "Pacific/Honolulu (Hawaii, US)" },
  { value: "America/Toronto", label: "America/Toronto (Canada Eastern)" },
  { value: "America/Vancouver", label: "America/Vancouver (Canada Pacific)" },
  { value: "America/Mexico_City", label: "America/Mexico_City" },
  { value: "America/Sao_Paulo", label: "America/Sao_Paulo (Brazil)" },
  { value: "America/Buenos_Aires", label: "America/Buenos_Aires (Argentina)" },
  { value: "Europe/London", label: "Europe/London (UK)" },
  { value: "Europe/Dublin", label: "Europe/Dublin (Ireland)" },
  { value: "Europe/Paris", label: "Europe/Paris" },
  { value: "Europe/Berlin", label: "Europe/Berlin" },
  { value: "Europe/Madrid", label: "Europe/Madrid" },
  { value: "Europe/Rome", label: "Europe/Rome" },
  { value: "Europe/Amsterdam", label: "Europe/Amsterdam" },
  { value: "Europe/Stockholm", label: "Europe/Stockholm" },
  { value: "Europe/Athens", label: "Europe/Athens" },
  { value: "Europe/Moscow", label: "Europe/Moscow" },
  { value: "Africa/Cairo", label: "Africa/Cairo" },
  { value: "Africa/Johannesburg", label: "Africa/Johannesburg" },
  { value: "Asia/Dubai", label: "Asia/Dubai (UAE)" },
  { value: "Asia/Karachi", label: "Asia/Karachi (Pakistan)" },
  { value: "Asia/Kolkata", label: "Asia/Kolkata (India)" },
  { value: "Asia/Kathmandu", label: "Asia/Kathmandu (Nepal)" },
  { value: "Asia/Dhaka", label: "Asia/Dhaka (Bangladesh)" },
  { value: "Asia/Bangkok", label: "Asia/Bangkok (Thailand)" },
  { value: "Asia/Jakarta", label: "Asia/Jakarta (Indonesia)" },
  { value: "Asia/Singapore", label: "Asia/Singapore" },
  { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai (China)" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo (Japan)" },
  { value: "Asia/Seoul", label: "Asia/Seoul (South Korea)" },
  { value: "Australia/Sydney", label: "Australia/Sydney" },
  { value: "Australia/Perth", label: "Australia/Perth" },
  { value: "Pacific/Auckland", label: "Pacific/Auckland (NZ)" },
];

export const LANGUAGES = [
  { value: "en-US", label: "English (US)" },
];

export const HOLIDAY_REGIONS = [
  { value: "USA", label: "🇺🇸 USA holidays" },
  { value: "India", label: "🇮🇳 India holidays" },
  { value: "UK", label: "🇬🇧 UK holidays" },
];

export const FEEDBACK_TYPES = [
  "Feature Request",
  "Bug Report",
  "General Feedback",
  "Enhancement",
  "Other",
];
